<template lang="pug">
table-base.study-result-detail-score-table
  table-row-base.study-result-detail-score-table__row
    table-header-base.study-result-detail-score-table__row__header
    table-header-base.study-result-detail-score-table__row__header.align-center
      slot(name='totalScoreHeader')
    table-header-base.study-result-detail-score-table__row__header.align-center
      slot(name='knowledgeScoreHeader')
    table-header-base.study-result-detail-score-table__row__header.align-center
      slot(name='thinkingScoreHeader')
  table-row-base.study-result-detail-score-table__row
    table-data-base.study-result-detail-score-table__row__header.align-center.font-bold
      slot(name='scoreLabel')
    table-data-base.study-result-detail-score-table__row__cell.align-center {{ studyResultDetailScore.totalScore }}
    table-data-base.study-result-detail-score-table__row__cell.align-center {{ studyResultDetailScore.knowledgeScore }}
    table-data-base.study-result-detail-score-table__row__cell.align-center {{ studyResultDetailScore.thinkingScore }}
  //- 平均点は一時的に非表示
  //- table-row-base.study-result-detail-score-table__row
  //-   table-data-base.study-result-detail-score-table__row__header.align-center.font-bold
  //-     slot(name='averageLabel')
  //-   table-data-base.study-result-detail-score-table__row__cell.align-center {{ studyResultDetailScore.totalAverage }}
  //-   table-data-base.study-result-detail-score-table__row__cell.align-center {{ studyResultDetailScore.knowledgeAverage }}
  //-   table-data-base.study-result-detail-score-table__row__cell.align-center {{ studyResultDetailScore.thinkingAverage }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import { StudyResultDetailScore } from '@/models/studyResultDetailModel'

/**
 * テスト結果詳細得点情報テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
  },
})
export default class StudyResultDetailScoreTable extends Vue {
  // テスト結果詳細得点情報
  @Prop()
  studyResultDetailScore!: StudyResultDetailScore
}
</script>

<style lang="stylus" scoped>
.study-result-detail-score-table
  width 100%

  &__row
    &__header, &__cell
      width 25%
      border 1px solid var(--color-study-list-table__border)

    &__header
      padding 5px
      background-color var(--color-study-list-head__background)
      color var(--color-study-list-head__text)

    &__cell
      padding 10px
</style>
